import { useEffect } from 'react';

/**
 * Meta Pixel base code — The No-Prep Chess Club Megapack.
 * Único pixel y único lugar donde se inicializa. Dispara PageView una sola
 * vez por carga de página (guard global contra re-montajes / StrictMode).
 */
const PIXEL_ID = '1637994954634530';
type FbqWindow = Window & {
  fbq?: unknown;
  __metaPixelPageViewSent?: boolean;
};
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as FbqWindow;
    if (w.__metaPixelPageViewSent || w.fbq) return;
    w.__metaPixelPageViewSent = true;
    const script = document.createElement('script');
    script.innerHTML = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${PIXEL_ID}');
fbq('track', 'PageView');`;
    document.head.appendChild(script);
  }, []);
  return null;
}